module.exports = __webpack_public_path__ + "img/pessoas-trabalhando-usando-tablet.jpg";